/*
 * Copyright (c) 2017-2026 Brighter AI Technologies GmbH. All rights reserved.
 * Unauthorized use, copying, reproduction, or distribution of this file, via any medium,
 * is strictly prohibited.
 */

import { PublicClientApplication } from "@azure/msal-browser";
import {
  msalConfig,
  getAccessTokenSilent,
  getAccountId,
  redirectRequest,
} from "./authConfig";
import * as gtmUtils from "../commons/gtmUtils.js";
const msalClient = new PublicClientApplication(msalConfig);

// Register Callbacks for Redirect flow
msalClient
  .handleRedirectPromise()
  .then(async (response) => {
    if (response) {
      await handleResponse(response);
    }
  })
  .catch(() => {
    window.location.href = "/";
  });

function handleResponse(resp) {
  const newUser = resp.idTokenClaims.newUser;
  if (resp !== null) {
    accountId = resp.account.homeAccountId;
    gtmUtils.dispatchGtmEvent("login", newUser ? "new user" : "returning user");
  } else {
    // need to call getAccount here?
    const currentAccounts = msalClient.getAllAccounts();
    if (!currentAccounts || currentAccounts.length < 1) {
      return;
    } else if (currentAccounts.length > 1) {
      accountId = currentAccounts[0].homeAccountId;
      // Add choose account code here
    } else if (currentAccounts.length === 1) {
      accountId = currentAccounts[0].homeAccountId;
    }
  }

  window.location.href = newUser ? "/#questionnaire" : "/";
}

var accountId = getAccountId(msalClient);

export const mockSetAccountId = (value) => {
  if (process.env.NODE_ENV !== "test") {
    throw new Error("attempted to use a test function for other purposes");
  }
  accountId = value;
};

const authorizationProvider = {
  // authentication
  login: async (params) => {
    if (accountId) {
      return Promise.resolve();
    }

    if (!params || !params.code || !params.state) {
      await msalClient.loginRedirect(redirectRequest);
    }

    return Promise.resolve();
  },
  checkError: (error) => {
    const status = error.status;
    if (status === 401 || status === 403) {
      return Promise.reject();
    }
    // other error code (404, 500, etc): no need to log out
    return Promise.resolve();
  },
  checkAuth: async () => {
    const token = await getAccessTokenSilent(msalClient, accountId);
    if (!token) return Promise.reject();
    if (token.idTokenClaims.isPasswordForgotten) {
      if (accountId !== null) {
        const currentAcc = msalClient.getAccountByHomeId(accountId);
        await msalClient.logout(currentAcc);

        accountId = null;
      }
    }
    return Promise.resolve();
  },
  logout: async () => {
    if (accountId !== null) {
      const currentAcc = msalClient.getAccountByHomeId(accountId);
      await msalClient.logout(currentAcc);

      accountId = null;
    }

    return Promise.resolve();
  },
  getIdentity: async () => {
    let user = JSON.parse(localStorage.getItem("user"));
    if (!user) {
      const token = await getAccessTokenSilent(msalClient, accountId);
      if (!token) {
        return Promise.reject();
      }

      const id = token.idTokenClaims.oid;
      const fullName =
        "" +
        token.idTokenClaims.given_name +
        " " +
        token.idTokenClaims.family_name;

      user = {
        id: id,
        fullName: fullName,
      };

      localStorage.setItem("user", JSON.stringify(user));
    }

    return Promise.resolve({
      id: user.id,
      fullName: user.fullName,
      undefined,
    });
  },
  getPermissions: (params) => {
    return accountId != null ? Promise.resolve() : Promise.reject();
  },
};

export default authorizationProvider;
